module.exports = __webpack_public_path__ + "./images/c11605ab076e3a968bd46c7cf6bd4dfb.png";